module.exports = __webpack_public_path__ + "img/index-lenses.b46bab5f.svg";